import { render } from "./ModalVisibilidad.vue?vue&type=template&id=064e3da7"
import script from "./ModalVisibilidad.vue?vue&type=script&lang=js"
export * from "./ModalVisibilidad.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__